import React from 'react'
import "../css/Events.css";
import { Card, Grid } from 'semantic-ui-react';

export default function EventCard({ date, startTime, event_name, description, ...rest }) {
    return (
        <Card className="events-card" color='blue' {...rest}>
            <Card.Content className='events-card-header'>
                <Grid className='events-event-header-grid'>
                    <Grid.Column floated='left' width={7}>
                        <p className='events-date'>{date}</p>
                    </Grid.Column>
                    <Grid.Column floated='right' width={7}>
                        <p className='events-time'>{startTime}</p>
                    </Grid.Column>
                </Grid>
            </Card.Content>
            <Card.Content>
                <p className='events-event-name'>{event_name}</p>
                <p className='events-event-desc'>{description}</p>
            </Card.Content>
            <Card.Content extra>
                <p className='events-learn-more'>Learn More &#62;</p>
            </Card.Content>
        </Card>
    )
}
